// This file contains the third image of the first project

export const PortfolioImg3 = ({ backgroundPic, t1, b1, t2, b2, t3, b3 }) => {
  return (
    <div className="hidden-on-desktop">
      <div
        className="image-filler project-image-responsive"
        id="text-qa-dashboard"
      ></div>
      <img
        className="project-image project-image-responsive"
        src={backgroundPic}
        alt="image of project"
      />

      <div className="overlapping-image-1-mobile">
        <img
          id="text-qa-left-right"
          className="check-mobile"
          src={t1}
          style={{ borderRadius: "30px", overflow: "hidden" }}
        />
        <img
          id="text-qa-left-right"
          className="check-mobile"
          src={b1}
          style={{ borderRadius: "30px", overflow: "hidden" }}
        />
      </div>

      <div className="overlapping-image-2-mobile">
        <img
          id="text-qa-left-right"
          className="check2-mobile"
          src={t2}
          style={{ borderRadius: "30px", overflow: "hidden" }}
        />
        <img
          id="text-qa-left-right"
          className="check2-mobile"
          src={b2}
          style={{ borderRadius: "30px", overflow: "hidden" }}
        />
      </div>

      <div className="overlapping-image-2-mobile">
        <img
          id="text-qa-left-right"
          className="check2-mobile"
          src={t3}
          style={{ borderRadius: "30px", overflow: "hidden" }}
        />
        <img
          id="text-qa-left-right"
          className="check2-mobile"
          src={b3}
          style={{ borderRadius: "30px", overflow: "hidden" }}
        />
      </div>
    </div>
  );
};
